import React from "react";
import { inlineStyle} from "../../../../constans/controlToolbar";
import { objToolbar } from "../../../../constans/controlToolbar";
import styles from '../EditorToolbar.module.scss'
import { Tooltip } from "antd";
import ControlBtn from "../../ControlBtn/ControlBtn"

const InlineStyleButton = ({ onClick, currentStyle}) => {
  return (
    <div className={styles.container}>
          {objToolbar[inlineStyle]?.map((type) => (
            <Tooltip key={type.inlineStyle} title={type.tooltipTitle}>
              <ControlBtn
                content={type.content}
                active={currentStyle.has(type.inlineStyle)}
                inlineStyle={type.inlineStyle}
                onClick={onClick}
              />
            </Tooltip>
          ))}
        </div>
  )
}

export default InlineStyleButton;
